<template>
  <div class="uk-container">
      <div class="uk-flex uk-flex-center uk-flex-middle" style="height: 100vh;">
          <div>
            <h1 style="padding-bottom: 0px; margin-bottom: 0px;">404</h1>
            <div>Not Found</div>
          </div>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>